import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/components/auth/AuthProvider';

export const useWeatherData = () => {
  const { user } = useAuth();

  const { data: weatherData } = useQuery({
    queryKey: ['next-run-weather'],
    queryFn: async () => {
      try {
        // Get user's current location
        const position = await new Promise<GeolocationPosition>((resolve, reject) => {
          if (!navigator.geolocation) {
            reject(new Error('Geolocation not supported'));
            return;
          }
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 10000,
            maximumAge: 300000 // 5 minutes
          });
        });

        // Call weather API with imperial units for Fahrenheit
        const { data } = await supabase.functions.invoke('get-weather', {
          body: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            units: 'imperial' // This will return temperature in Fahrenheit
          }
        });

        return data;
      } catch (error) {
        console.log('Weather data not available:', error);
        return null;
      }
    },
    enabled: !!user,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: false
  });

  return { weatherData };
};